import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ServiceLeafTemplate from "@/components/templates/ServiceLeafTemplate";
import { SERVICE_PAGES } from "@/data/pageContent";

const ServiceLeafPage = () => {
  const { slug } = useParams();
  const data = SERVICE_PAGES[slug];
  if (!data) return <Navigate to="/services" replace />;
  return <ServiceLeafTemplate data={data} />;
};

export default ServiceLeafPage;
